import { render, staticRenderFns } from "./ConfigAgendamentoAnaliseInvalida.vue?vue&type=template&id=27bd6614&"
import script from "./ConfigAgendamentoAnaliseInvalida.vue?vue&type=script&lang=js&"
export * from "./ConfigAgendamentoAnaliseInvalida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports